import { DateRange } from '../../redux/dateRangeSlice';
import { get } from '..';

const getSensors = (deviceId?: string, range?: DateRange) => {
  let endpoint: string = 'assets/sensors';
  if (deviceId) endpoint += `/${deviceId}`;
  if (range) endpoint += `?from=${range.start}&to=${range.end}`;
  return get(endpoint);
};

export default getSensors;
